var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12010",
    "data-name": "Rectangle 12010",
    width: 30,
    height: 30,
    fill: "#393939"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37565",
    "data-name": "Group 37565",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21593",
    "data-name": "Path 21593",
    d: "M9.768,27.172a.577.577,0,0,1-.32-.1l-1.441-.961-1.441.961a.577.577,0,0,1-.9-.48V3.7a.577.577,0,0,1,.9-.48l1.441.961,1.441-.961a.58.58,0,0,1,.64,0l1.441.961,1.441-.961a.579.579,0,0,1,.64,0l1.441.961,1.441-.961a.579.579,0,0,1,.64,0l1.441.961,1.441-.961a.577.577,0,0,1,.9.48v9.039H19.757V4.781l-.864.576a.576.576,0,0,1-.64,0L16.812,4.4l-1.441.961a.576.576,0,0,1-.64,0L13.29,4.4l-1.441.961a.576.576,0,0,1-.64,0L9.768,4.4l-1.441.961a.576.576,0,0,1-.64,0l-.864-.576V25.516l.864-.576a.574.574,0,0,1,.64,0l1.441.961,1.441-.961a.574.574,0,0,1,.64,0l1.705,1.137-.64.96-1.385-.924-1.441.961a.577.577,0,0,1-.32.1",
    transform: "translate(-2.399 -1.323)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12002",
    "data-name": "Rectangle 12002",
    width: 5.263,
    height: 1.154,
    transform: "translate(6.205 8.847)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12003",
    "data-name": "Rectangle 12003",
    width: 2.328,
    height: 1.154,
    transform: "translate(13.249 8.847)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12004",
    "data-name": "Rectangle 12004",
    width: 5.263,
    height: 1.154,
    transform: "translate(6.205 11.195)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12005",
    "data-name": "Rectangle 12005",
    width: 5.263,
    height: 1.154,
    transform: "translate(6.205 13.543)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12006",
    "data-name": "Rectangle 12006",
    width: 2.328,
    height: 1.154,
    transform: "translate(13.249 11.195)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12007",
    "data-name": "Rectangle 12007",
    width: 2.328,
    height: 1.154,
    transform: "translate(13.249 13.543)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12008",
    "data-name": "Rectangle 12008",
    width: 4.089,
    height: 1.154,
    transform: "translate(6.205 19.412)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21594",
    "data-name": "Path 21594",
    d: "M25.616,35.271c-2.328,0-4.685-.8-4.685-2.338S23.288,30.6,25.616,30.6s4.686.8,4.686,2.338-2.357,2.338-4.686,2.338m0-3.522c-2.191,0-3.531.766-3.531,1.184s1.341,1.184,3.531,1.184,3.532-.767,3.532-1.184-1.341-1.184-3.532-1.184",
    transform: "translate(-8.855 -12.944)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21595",
    "data-name": "Path 21595",
    d: "M25.616,39.92c-2.328,0-4.685-.8-4.685-2.338V34.647h1.154v2.935c0,.418,1.341,1.184,3.531,1.184s3.532-.767,3.532-1.184V34.647H30.3v2.935c0,1.535-2.357,2.338-4.686,2.338",
    transform: "translate(-8.855 -14.658)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21596",
    "data-name": "Path 21596",
    d: "M25.616,44.584c-2.328,0-4.685-.8-4.685-2.338V38.734h1.154v3.512c0,.418,1.341,1.184,3.531,1.184s3.532-.767,3.532-1.184V38.734H30.3v3.512c0,1.535-2.357,2.338-4.686,2.338",
    transform: "translate(-8.855 -16.387)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21597",
    "data-name": "Path 21597",
    d: "M38.238,34.427l-.071-1.152.576-.036c1.957-.12,2.98-.823,2.98-1.167V28.561h1.154v3.512c0,1.237-1.633,2.17-4.063,2.319Z",
    transform: "translate(-16.148 -12.083)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21598",
    "data-name": "Path 21598",
    d: "M34.773,25.1c-2.328,0-4.686-.8-4.686-2.338s2.357-2.338,4.686-2.338,4.685.8,4.685,2.338S37.1,25.1,34.773,25.1m0-3.522c-2.191,0-3.532.767-3.532,1.184s1.341,1.184,3.532,1.184S38.3,23.177,38.3,22.76s-1.341-1.184-3.531-1.184",
    transform: "translate(-12.729 -8.64)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12009",
    "data-name": "Rectangle 12009",
    width: 1.154,
    height: 2.925,
    transform: "translate(17.358 14.12)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21599",
    "data-name": "Path 21599",
    d: "M37.85,29.761l-.043-1.153.576-.021c2.092-.08,3.187-.809,3.187-1.177V24.474h1.154v2.935c0,1.276-1.767,2.234-4.3,2.33Z",
    transform: "translate(-15.995 -10.354)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21600",
    "data-name": "Path 21600",
    d: "M38.235,39.513l-.07-1.152.576-.035c1.957-.119,2.98-.823,2.98-1.167V33.647h1.154v3.512c0,1.238-1.633,2.17-4.064,2.319Z",
    transform: "translate(-16.147 -14.235)",
    fill: "#393939"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceInactive);
export default __webpack_public_path__ + "static/media/invoiceInactive.8dc892178b27fd385d607b87d1d83851.svg";
export { ForwardRef as ReactComponent };